import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isLoadingParticipants: false,
  isLoadingParticipantLeaderBoard: false,
  isLoadingSingleParticipant: false,
  isLoadingSingleQuizathon: false,
  isCreatingQuizathon: false,
  isDeletingQuizathon: false,
  isEditingQuizathon: false,
  quizathonList: [],
  participants: [],
  singleQuizathon: {},
  singleParticipant: {},
  participantLeaderBoard:[]
};

export const quizathonSlice = createSlice({
  name: "quizaton",
  initialState,
  reducers: {
    getQuizathonStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getQuizathonSuccess: (state, action) => {
      state.isLoading = false;
      state.quizathonList = action.payload;
      state.error = null;
    },
    getQuizathonFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createQuizathonStart: (state, action) => {
      state.isCreatingQuizathon = true;
      state.error = null;
    },
    createQuizathonSuccess: (state, action) => {
      state.isCreatingQuizathon = false;
      state.error = null;
    },
    createQuizathonFailure: (state, action) => {
      state.isCreatingQuizathon = false;
      state.error = action.payload;
    },
    editQuizathonStart: (state, action) => {
      state.isEditingQuizathon = true;
      state.error = null;
    },
    editQuizathonSuccess: (state, action) => {
      state.isEditingQuizathon = false;
      state.error = null;
    },
    editQuizathonFailure: (state, action) => {
      state.isEditingQuizathon = false;
      state.error = action.payload;
    },
    deleteQuizathonStart: (state, action) => {
      state.isDeletingQuizathon = true;
      state.error = null;
    },
    deleteQuizathonSuccess: (state, action) => {
      state.isDeletingQuizathon = false;
      state.error = null;
    },
    deleteQuizathonFailure: (state, action) => {
      state.isDeletingQuizathon = false;
      state.error = action.payload;
    },
    getParticipantsStart: (state) => {
      state.isLoadingParticipants = true;
      state.error = null;
    },
    getParticipantsSuccess: (state, action) => {
      state.isLoadingParticipants = false;
      state.participants = action.payload;
      state.error = null;
    },
    getParticipantsFailure: (state, action) => {
      state.isLoadingParticipants = false;
      state.error = action.payload;
    },
    getSingleQuizathonStart: (state) => {
      state.isLoadingSingleQuizathon = true;
      state.error = null;
    },
    getSingleQuizathonSuccess: (state, action) => {
      state.isLoadingSingleQuizathon = false;
      state.singleQuizathon = action.payload;
      state.error = null;
    },
    getSingleQuizathonFailure: (state, action) => {
      state.isLoadingSingleQuizathon = false;
      state.error = action.payload;
    },
    getSingleParticipantStart: (state) => {
      state.isLoadingSingleParticipant = true;
      state.error = null;
    },
    getSingleParticipantSuccess: (state, action) => {
      state.isLoadingSingleParticipant = false;
      state.singleParticipant = action.payload;
      state.error = null;
    },
    getSingleParticipantFailure: (state, action) => {
      state.isLoadingSingleParticipant = false;
      state.error = action.payload;
    },
    getParticipantLeaderboardStart: (state) => {
      state.isLoadingParticipantLeaderBoard = true;
      state.error = null;
    },
    getParticipantLeaderboardSuccess: (state, action) => {
      state.isLoadingParticipantLeaderBoard = false;
      state.participantLeaderBoard = action.payload;
      state.error = null;
    },
    getParticipantLeaderboardFailure: (state, action) => {
      state.isLoadingParticipantLeaderBoard = false;
      state.error = action.payload;
    },
  },
});

export const {
  getQuizathonFailure,
  getQuizathonSuccess,
  getQuizathonStart,
  createQuizathonFailure,
  createQuizathonStart,
  createQuizathonSuccess,
  editQuizathonFailure,
  editQuizathonStart,
  editQuizathonSuccess,
  deleteQuizathonFailure,
  deleteQuizathonStart,
  deleteQuizathonSuccess,
  getParticipantsStart,
  getParticipantsSuccess,
  getParticipantsFailure,
  getSingleQuizathonFailure,
  getSingleQuizathonStart,
  getSingleQuizathonSuccess,
  getSingleParticipantFailure,
  getSingleParticipantStart,
  getSingleParticipantSuccess,
  getParticipantLeaderboardFailure,
  getParticipantLeaderboardStart,
  getParticipantLeaderboardSuccess
} = quizathonSlice.actions;

const quizathonsReducer = quizathonSlice.reducer;
export default quizathonsReducer;
